import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { OrderServicesTicket } from 'gung-standard';
import { ReturnWarrantyListConfigService } from 'gung-standard';
import { TyloReturnWarrantyTableComponent } from '../components/tylo-return-warranty-table/tylo-return-warranty-table.component';
import { TyloOrderServicesService } from './tylo-order-services.service';

class TyloReturnWarrantyStatusFilter extends SimpleConfigBaseFilter<OrderServicesTicket> {
  getOptionIds(item: OrderServicesTicket): string[] {
    if (String(item.extra?.claimWorkflow) !== '30') {
      return [];
    }

    return item.extra?.bytekund ? ['RETURNED_TO_TYLO'] : ['NOT_RETURNED_TO_TYLO'];
  }

  getOptionName(key: string): string {
    return key;
  }

  getName(): string {
    return 'RETURN_STATUS';
  }
}

@Injectable({
  providedIn: 'root'
})
export class TyloReturnWarrantyListConfigService extends ReturnWarrantyListConfigService {
  protected orderServicesService = inject(TyloOrderServicesService);

  getLayouts(): ListLayout<OrderServicesTicket>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => TyloReturnWarrantyTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getSearchTerms(item: OrderServicesTicket): string[] {
    return [item.id, item.orderId, item.extra?.productId, item.extra?.rmaNr];
  }

  getFilters(): ConfigBaseFilter<OrderServicesTicket>[] {
    const filters = super.getFilters();
    filters.push(new TyloReturnWarrantyStatusFilter());
    return filters;
  }
}
